import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { InputProps } from './index';
import { Input } from './index';

interface ControlledInputProps<TFields extends FieldValues, TName extends Path<TFields>> extends Omit<
  InputProps,
  'error' | 'onBlur' | 'onChange' | 'onChangeText' | 'value'
> {
  control: Control<TFields>;
  name: TName;
  nullable?: boolean;
  innerRef?: InputProps['innerRef'];
  autoWidth?: boolean;
  onChangeText?: (text: string | null) => void;
}

export function ControlledInput<TFields extends FieldValues, TName extends Path<TFields>>({
  control,
  name,
  nullable,
  innerRef,
  autoWidth,
  ...rest
}: ControlledInputProps<TFields, TName>) {
  return (
    <Controller
      {...{ control, name }}
      render={({ field, fieldState }) => (
        <Input
          {...rest}
          autoWidth={autoWidth}
          error={fieldState.error}
          innerRef={innerRef}
          onBlur={field.onBlur}
          onChangeText={(text) => {
            if (nullable) {
              field.onChange(text || null);
            } else {
              field.onChange(text);
            }
            if (rest.onChangeText) {
              rest.onChangeText(text);
            }
          }}
          value={field.value}
        />
      )}
    />
  );
}
